import { Input } from './input'

// https://github.com/chakra-ui/chakra-ui/blob/master/packages/theme/src/components/textarea.ts
export const Textarea = {
  baseStyle: {
    ...Input.baseStyle.field,
    paddingY: 'initial',
    minHeight: 'initial',
    lineHeight: 'initial',
  },
  sizes: {
    md: Input.sizes.md.field,
  },
  variants: {
    outline: (props) => Input.variants.outline(props).field,
  },
}
